import { render } from "./SideBaar.vue?vue&type=template&id=704c635e&scoped=true"
import script from "./SideBaar.vue?vue&type=script&lang=js"
export * from "./SideBaar.vue?vue&type=script&lang=js"

import "./SideBaar.vue?vue&type=style&index=0&id=704c635e&lang=scss&scoped=true"

import exportComponent from "C:\\Projects\\KneeLeadNew\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-704c635e"]])

export default __exports__